<script lang="ts">
  import { Router, Route, NotFoundRoute, redirect } from "./utils/pager";
  import { isUserRoleADM, isUserRoleWOR, isUserRoleVET, isUserRoleQCC, user } from "./app.store";
  import { initialize } from "./app.logic";
  import { get } from "svelte/store";
  import LoginPage from "./pages/Login/LoginPage.svelte";
  //import DashboardPage from "./pages/Dashboard/DashboardPage.svelte";
  import ProfilePage from "./pages/Profile/ProfilePage.svelte";
  import NotFoundPage from "./pages/NotFound/NotFoundPage.svelte";
  import UserListPage from "./pages/User/UserListPage.svelte";
  import SettingsPage from "./pages/Settings/SettingsPage.svelte";
  import UserDetailPage from "./pages/User/UserDetailPage.svelte";
  import CustomerListPage from "./pages/Customer/CustomerListPage.svelte";
  import CustomerDetailPage from "./pages/Customer/CustomerDetailPage.svelte";
  import ButcherIngredientListPage from "./pages/ButcherIngredientStock/ButcherIngredientListPage.svelte";
  import ButcherIngredientDetailPage from "./pages/ButcherIngredientStock/ButcherIngredientDetailPage.svelte";
  import ButcherMaterialListPage from "./pages/ButcherMaterialStock/ButcherMaterialListPage.svelte";
  import ButcherMaterialDetailPage from "./pages/ButcherMaterialStock/ButcherMaterialDetailPage.svelte";
  import ProductTypeListPage from "./pages/ProductType/ProductTypeListPage.svelte";
  import ProductTypeDetailPage from "./pages/ProductType/ProductTypeDetailPage.svelte";
  import ButcherSlaughterListPage from "./pages/ButcherWork/ButcherSlaughterListPage.svelte";
  import ButcherSlaughterDetailPage from "./pages/ButcherWork/ButcherSlaughterDetailPage.svelte";
  import ButcherSectionListPage from "./pages/ButcherWork/ButcherSectionListPage.svelte";
  import ButcherSectionDetailPage from "./pages/ButcherWork/ButcherSectionDetailPage.svelte";
  import ButcherTransformListPage from "./pages/ButcherWork/ButcherTransformListPage.svelte";
  import ButcherTransformDetailPage from "./pages/ButcherWork/ButcherTransformDetailPage.svelte";
  import RecipeListPage from "./pages/Recipe/RecipeListPage.svelte";
  import RecipeDetailPage from "./pages/Recipe/RecipeDetailPage.svelte";
  import EntranceListPage from "./pages/Entrance/EntranceListPage.svelte";
  import WeightLabelListPage from "./pages/WeightLabel/WeightLabelListPage.svelte";
  import VisitListPage from "./pages/Visit/VisitListPage.svelte";
  import TransportDocumentListPage from "./pages/TransportDocument/TransportDocumentListPage.svelte";
  import TransportDocumentDetailPage from "./pages/TransportDocument/TransportDocumentDetailPage.svelte";
  import VisitHistoryListPage from "./pages/VisitHistory/VisitHistoryListPage.svelte";
  import VisitHistoryDetailPage from "./pages/VisitHistory/VisitHistoryDetailPage.svelte";
  import PdfTestPage from "./pages/PdfTest/PdfTestPage.svelte";
  import TraceabilityListPage from "./pages/Traceability/TraceabilityListPage.svelte";
  import QualityManualPage from "./pages/QualityManual/QualityManualPage.svelte";
  import QualityProceduresMainPage from "./pages/QualityProcedures/QualityProceduresMainPage.svelte";
  import QualityIncidentListPage from "./pages/QualityProcedures/QualityIncident/QualityIncidentListPage.svelte";
  import QualityIncidentDetailPage from "./pages/QualityProcedures/QualityIncident/QualityIncidentDetailPage.svelte";
  import QualitySanificationPage from "./pages/QualityProcedures/QualitySanification/QualitySanificationPage.svelte";
  import QualityInfestantsPage from "./pages/QualityProcedures/QualityInfestants/QualityInfestantsPage.svelte";
  import QualityH2OPage from "./pages/QualityProcedures/QualityH2O/QualityH2OPage.svelte";
  import QualityExternalMaintenancePage from "./pages/QualityProcedures/QualityExternalMaintenance/QualityExternalMaintenancePage.svelte";
  import QualityCalibrationPage from "./pages/QualityProcedures/QualityCalibration/QualityCalibrationPage.svelte";
  import QualityWelfarePage from "./pages/QualityProcedures/QualityWelfare/QualityWelfarePage.svelte";
  import QualityWasteListPage from "./pages/QualityProcedures/QualityWaste/QualityWasteListPage.svelte";
  import QualityWasteDetailPage from "./pages/QualityProcedures/QualityWaste/QualityWasteDetailPage.svelte";
  import QualityTrainingPage from "./pages/QualityProcedures/QualityTraining/QualityTrainingPage.svelte";
  import QualityAtpPage from "./pages/QualityProcedures/QualityATP/QualityATPPage.svelte";
  import QualityAnalysisPage from "./pages/QualityProcedures/QualityAnalysis/QualityAnalysisPage.svelte";
  import QualityAnalysisSchedulePage from "./pages/QualityProcedures/QualityAnalysisSchedule/QualityAnalysisSchedulePage.svelte";
  import QualityMaintenanceScheduleListPage from "./pages/QualityProcedures/QualityMaintenanceSchedule/QualityMaintenanceScheduleListPage.svelte";
  import QualityMaintenanceScheduleDetailPage from "./pages/QualityProcedures/QualityMaintenanceSchedule/QualityMaintenanceScheduleDetailPage.svelte";
  import QualityInternalMaintenanceListPage from "./pages/QualityProcedures//QualityInternalMaintenance/QualityInternalMaintenanceListPage.svelte";
  import QualityInternalMaintenanceDetailPage from "./pages/QualityProcedures/QualityInternalMaintenance/QualityInternalMaintenanceDetailPage.svelte";

  // const data1 = { foo: "bar", custom: true };

  const loginGuard = (_ctx: any, next: any) => {
    // user.subscribe((u) => {
    // console.log("loginGuard user:", u);
    let u = get(user);
    // check if user is authenticated
    if (u === null) {
      // redirect("/login");
      initialize();
    } else {
      // go to the next callback in the chain
      next();
      //redirect("/dashboard");
    }
    // });
  };

  const adminGuard = (_ctx: any, next: any) => {
    let adm = get(isUserRoleADM);
    if (!adm) {
      redirect("/");
    } else {
      next();
    }
  };

  const editGuard = (_ctx: any, next: any) => {
    let adm = get(isUserRoleADM);
    let wor = get(isUserRoleWOR);
    if (!adm && !wor) {
      redirect("/");
    } else {
      next();
    }
  };

  const defaultRouteGuard = (_ctx: any, _next: any) => {
    if (get(isUserRoleVET)) {
      redirect("/butcher-visits");
      return;
    }
    if (get(isUserRoleWOR)) {
      redirect("/butcher-entrance");
      return;
    }
    if (get(isUserRoleQCC)) {
      redirect("/quality-main");
      return;
    }
    redirect("/customer");
  };
  const redirectSlaughterRouteGuard = (_ctx: any, _next: any) => {
    redirect("/butcher-work/slaughter");
  };

  // onMount(initialize);
</script>

<Router>
  <Route path="/" middleware={[loginGuard, defaultRouteGuard]}>
    <div class="initial-loader" />
  </Route>
  <Route path="/login" component={LoginPage} />
  <!--
  <Route
    middleware={[loginGuard]}
    path="/profile/:username"
    component={ProfilePage}
  />
  -->
  <!-- <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} data={data1} /> -->
  <Route path="/profile" middleware={[loginGuard]} component={ProfilePage} />
  <!-- <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} /> -->
  <Route path="/customer" middleware={[loginGuard, editGuard]} component={CustomerListPage} />
  <Route path="/customer/:oid" middleware={[loginGuard, editGuard]} component={CustomerDetailPage} />
  <Route path="/transport-document" middleware={[loginGuard, adminGuard]} component={TransportDocumentListPage} />
  <Route path="/transport-document/:oid" middleware={[loginGuard, adminGuard]} component={TransportDocumentDetailPage} />
  <!-- BUTCHER -->
  <Route path="/butcher-ingredients" middleware={[loginGuard, adminGuard]} component={ButcherIngredientListPage} />
  <Route path="/butcher-ingredients/:oid" middleware={[loginGuard, adminGuard]} component={ButcherIngredientDetailPage} />
  <Route path="/butcher-materials" middleware={[loginGuard, adminGuard]} component={ButcherMaterialListPage} />
  <Route path="/butcher-materials/:oid" middleware={[loginGuard, adminGuard]} component={ButcherMaterialDetailPage} />
  <!-- <Route path="/butcher-work" middleware={[loginGuard, editGuard, redirectSlaughterRouteGuard]} /> -->
  <Route path="/butcher-work/slaughter" middleware={[loginGuard, editGuard]} component={ButcherSlaughterListPage} />
  <Route path="/butcher-work/slaughter/:oid" middleware={[loginGuard, editGuard]} component={ButcherSlaughterDetailPage} />
  <Route path="/butcher-work/section" middleware={[loginGuard, adminGuard]} component={ButcherSectionListPage} />
  <Route path="/butcher-work/section/:oid" middleware={[loginGuard, editGuard]} component={ButcherSectionDetailPage} />
  <Route path="/butcher-work/transform" middleware={[loginGuard, adminGuard]} component={ButcherTransformListPage} />
  <Route path="/butcher-work/transform/:oid" middleware={[loginGuard, editGuard]} component={ButcherTransformDetailPage} />
  <Route path="/recipe" middleware={[loginGuard, adminGuard]} component={RecipeListPage} />
  <Route path="/recipe/:oid" middleware={[loginGuard, adminGuard]} component={RecipeDetailPage} />
  <Route path="/product-type" middleware={[loginGuard, adminGuard]} component={ProductTypeListPage} />
  <Route path="/product-type/:oid" middleware={[loginGuard, adminGuard]} component={ProductTypeDetailPage} />
  <Route path="/traceability" middleware={[loginGuard, adminGuard]} component={TraceabilityListPage} />

  <!-- ADMIN + VET + WORKER -->
  <Route path="/butcher-entrance" middleware={[loginGuard, editGuard]} component={EntranceListPage} />
  <Route path="/butcher-weight-label" middleware={[loginGuard, editGuard]} component={WeightLabelListPage} />
  <Route path="/butcher-visits" middleware={[loginGuard]} component={VisitListPage} />
  <Route path="/butcher-visit-history" middleware={[loginGuard]} component={VisitHistoryListPage} />
  <Route path="/butcher-visit-history/:date" middleware={[loginGuard]} component={VisitHistoryDetailPage} />

  <!-- ADMIN + VET + QCC -->
  <Route path="/quality-manual" middleware={[loginGuard]} component={QualityManualPage} />
  <Route path="/quality-procs" middleware={[loginGuard]} component={QualityProceduresMainPage} />
  <Route path="/quality-sanification" middleware={[loginGuard]} component={QualitySanificationPage} />
  <Route path="/quality-infest" middleware={[loginGuard]} component={QualityInfestantsPage} />
  <Route path="/quality-h2o" middleware={[loginGuard]} component={QualityH2OPage} />
  <Route path="/quality-external-maintenance" middleware={[loginGuard]} component={QualityExternalMaintenancePage} />
  <Route path="/quality-internal-maintenance" middleware={[loginGuard]} component={QualityInternalMaintenanceListPage} />
  <Route path="/quality-internal-maintenance/:oid" middleware={[loginGuard]} component={QualityInternalMaintenanceDetailPage} />
  <Route path="/quality-calibration" middleware={[loginGuard]} component={QualityCalibrationPage} />
  <Route path="/quality-welfare" middleware={[loginGuard]} component={QualityWelfarePage} />
  <Route path="/quality-waste" middleware={[loginGuard]} component={QualityWasteListPage} />
  <Route path="/quality-waste/:oid" middleware={[loginGuard]} component={QualityWasteDetailPage} />
  <Route path="/quality-training" middleware={[loginGuard]} component={QualityTrainingPage} />
  <Route path="/quality-atp" middleware={[loginGuard]} component={QualityAtpPage} />
  <Route path="/quality-analysis" middleware={[loginGuard]} component={QualityAnalysisPage} />
  <Route path="/quality-schedule-analysis" middleware={[loginGuard]} component={QualityAnalysisSchedulePage} />
  <Route path="/quality-incident" middleware={[loginGuard]} component={QualityIncidentListPage} />
  <Route path="/quality-incident/:oid" middleware={[loginGuard]} component={QualityIncidentDetailPage} />
  <Route path="/quality-schedule-maintenance" middleware={[loginGuard]} component={QualityMaintenanceScheduleListPage} />
  <Route path="/quality-schedule-maintenance/:oid" middleware={[loginGuard]} component={QualityMaintenanceScheduleDetailPage} />

  <!-- ADMIN -->
  <Route path="/user" middleware={[loginGuard, adminGuard]} component={UserListPage} />
  <Route path="/user/:oid" middleware={[loginGuard, adminGuard]} component={UserDetailPage} />
  <Route path="/settings" middleware={[loginGuard, adminGuard]} component={SettingsPage} />

  <!-- TEST -->
  <Route path="/pdf-test" middleware={[loginGuard]} component={PdfTestPage} />

  <!--
    <Route
      path="/profile/:username"
      let:params
      middleware={[guard]}
      component={Profile}
    />
    -->
  <NotFoundRoute>
    <NotFoundPage />
  </NotFoundRoute>
</Router>

<!--<style>
  main {
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
  nav a {
    padding-right: 3rem;
  }
</style>-->
